module.exports = __webpack_public_path__ + "assets/img/visual1.9aeb8f12.png";